import CustomSelect from 'components/CustomSelect'
import { GET, httpOk, POST } from 'helpers/api'
import { roles } from 'helpers/helpers'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import MaskedInput from 'react-text-mask'

const initialState = {
	"role": "",
	"user_name": "",
	"password": "",
	"fio": "",
	"phone_number": "",
	"is_active": true,
	"shift_start": "",
	"shift_end": ""
};


function UserModal({ modal, setModal, reload }) {
	const { t } = useTranslation();

	const statuses = [
		{
			id: true,
			name: t('active')
		},
		{
			id: false,
			name: t('not_active')
		},
	];

	const [sendData, setSendData] = useState({ ...initialState });
	const [errors, setErrors] = useState({});
	const [warehouses, setWarehouses] = useState([]);

	const validate = () => {
		let newErrors = {};

		// Для ключа "Поле обязательно для заполнения" стоит добавить перевод в JSON, 
		// пока использую t() для возможности локализации в будущем
		if (!sendData.user_name) newErrors.user_name = t('required_field');
		if (!sendData.password) newErrors.password = t('required_field');
		if (!sendData.role) newErrors.role = t('select_role');

		if (sendData.role === 'sales') {
			if (!sendData.shift_start) newErrors.shift_start = t('select_time');
			if (!sendData.shift_end) newErrors.shift_end = t('select_time');
		}

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	async function create() {
		if (!validate()) return;

		var payload = { ...sendData };

		if (payload.role === 'sales') {
			payload = {
				...payload,
				shift_start: sendData.shift_start ? `${sendData.shift_start}:00` : null,
				shift_end: sendData.shift_end ? `${sendData.shift_end}:00` : null,
			}
		} else {
			delete payload.shift_start;
			delete payload.shift_end;
		}

		const response = await POST('/users/management/users/', payload);
		if (httpOk(response)) {
			reload();
			setModal(false)
			setSendData(initialState);
			setErrors({});
		}
	}

	async function getWarehouses(option) {
		const response = await GET('/inventory/warehouses/')
		if (httpOk(response)) {
			response.data = response.data.filter(item => item.warehouse_type === option.warehouseType)
			setWarehouses(response.data)
			if (response.data.length === 1) {
				setSendData({ ...sendData, warehouse_id: response.data[0]['id'], role: option?.id })
			}
		}
	}

	function selectRole(option) {
		if (option?.warehouseType) {
			getWarehouses(option)
		} else {
			setSendData({ ...sendData, role: option?.id })
		}
	}

	function handleChange(e) {
		const { name, value } = e.target;
		setSendData(prev => ({ ...prev, [name]: value }));
	}

	useEffect(() => {
		if (!modal) {
			setSendData(initialState);
			setErrors({});
		}
	}, [modal]);

	return (
		<>
			<Modal show={modal} centered onHide={() => setModal(false)}>
				<i className="uil-times" onClick={() => setModal(false)}></i>
				<div className="modal-title mb-12">
					{t('add_user')}
				</div>
				<div className="modal-subtitle mb-32">
					{t('enter_name_and_role')}
				</div>

				<div className="d-flex flex-column gap-16 mb-32">
					<div className="form-group">
						<label>{t('login')} <span className="text-danger">*</span></label>
						<input
							type="text"
							name="user_name"
							placeholder={t('enter_login_or_email')}
							value={sendData.user_name}
							onChange={handleChange}
						/>
						{errors.user_name && <span className="error-message">{errors.user_name}</span>}
					</div>

					<div className="form-group">
						<label>{t('password')} <span className="text-danger">*</span></label>
						<input
							type="password"
							name="password"
							placeholder={t('enter_password')}
							value={sendData.password}
							onChange={handleChange}
						/>
						{errors.password && <span className="error-message">{errors.password}</span>}
					</div>

					<div className="form-group">
						<label>{t('role')} <span className="text-danger">*</span> </label>
						<CustomSelect
							options={roles}
							value={roles.find(option => option.id === sendData?.role) || ''}
							onChange={(option) => selectRole(option)}
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
							placeholder={t('select_role')}
						/>
						{errors.role && <span className="error-message">{errors.role}</span>}
					</div>

					{sendData.role === 'sales' &&
						<div className="grid2 gap-8">
							<div className="form-group">
								<label>{t('shift_start')}</label>
								<MaskedInput
									type="text"
									placeholder='00:00'
									mask={[/[0-2]/, /\d/, ':', /[0-5]/, /\d/]}
									guide={false}
									value={sendData.shift_start}
									onChange={(e) => setSendData({ ...sendData, shift_start: e.target.value })}
								/>
								{errors.shift_start && <span className="error-message">{errors.shift_start}</span>}
							</div>
							<div className="form-group">
								<label>{t('shift_end')}</label>
								<MaskedInput
									type="text"
									placeholder='00:00'
									mask={[/[0-2]/, /\d/, ':', /[0-5]/, /\d/]}
									guide={false}
									value={sendData.shift_end}
									onChange={(e) => setSendData({ ...sendData, shift_end: e.target.value })}
								/>
								{errors.shift_end && <span className="error-message">{errors.shift_end}</span>}
							</div>
						</div>
					}

					{(sendData.role === 'warehouse_raw' || sendData.role === 'warehouse_finished' || sendData.role === 'production') &&
						<div className="form-group">
							<label>{t('warehouse')} <span className="text-danger">*</span> </label>
							<CustomSelect
								options={warehouses}
								value={warehouses?.find(option => option.id === sendData?.warehouse_id) || ''}
								onChange={(option) => setSendData({ ...sendData, warehouse_id: option?.id })}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
								placeholder={t('select_role')}
							/>
							{errors.role && <span className="error-message">{errors.role}</span>}
						</div>
					}

					<div className="form-group">
						<label>{t('username')}</label>
						<input
							type="text"
							placeholder={t('full_name')}
							name="fio"
							value={sendData.fio}
							onChange={handleChange}
						/>
					</div>

					<div className="form-group">
						<label>{t('phone')}</label>
						<input
							type="text"
							placeholder='+998 xx xxx xx xx'
							name="phone_number"
							value={sendData.phone_number}
							onChange={handleChange}
						/>
					</div>

					<div className="form-group">
						<label>{t('status')}</label>
						<CustomSelect
							options={statuses}
							value={statuses.find(option => option.id === sendData?.is_active) || ''}
							onChange={(option) => setSendData({ ...sendData, is_active: option?.id })}
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
							placeholder={t('select_status')}
						/>
					</div>
				</div>

				<div className="modal-footer">
					<button className="white" onClick={() => setModal(false)}>
						{t('cancel')}
					</button>
					<button className="dark" onClick={create}>
						{t('add')}
					</button>
				</div>
			</Modal>
		</>
	)
}

export default UserModal